export const getPageButtons = (page, lastPage, maxPageButtons) => {
  if (lastPage <= maxPageButtons) {
    return Array.from({ length: lastPage }).map((_item, index) => index + 1);
  }

  const pageButtons = Array.from({ length: maxPageButtons }).map(
    (_item, index) => {
      const offset = Math.ceil(maxPageButtons / 2) - 1;
      return page - offset + index;
    },
  );

  if (pageButtons[0] < 1) {
    const offsetFromStart = 1 - pageButtons[0];
    return pageButtons.map((item) => item + offsetFromStart);
  }

  if (pageButtons[pageButtons.length - 1] > lastPage) {
    const offsetFromEnd = pageButtons[pageButtons.length - 1] - lastPage;
    return pageButtons.map((item) => item - offsetFromEnd);
  }

  return pageButtons;
};
